<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <app-page-container v-else>
      <app-cells v-if="table_hotels_proceed.length" :indent="false">
        <h2 class="title title--mb15">Proceed</h2>
      </app-cells>
      <template v-if="table_hotels_proceed.length">
        <AppAccHotel
          v-for="(item, index) in table_hotels_proceed"
          :key="`hotel_proceed_${item.id}`"
          :reservation="item.reservation"
          :order-number="index + 1"
        />
        <app-cells :position="pagination_hotels_proceed.pages > 1 ? 'between' : 'end'">
          <paginate
            :clickHandler="onClickHotelsProceedPagination"
            v-if="pagination_hotels_proceed.pages > 1"
            v-model="pagination_hotels_proceed.page"
            :page-count="pagination_hotels_proceed.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
          <app-table-records
            :all="pagination_hotels_proceed.count"
            :count="table_hotels_proceed.length"
            :page="pagination_hotels_proceed.page"
          />
        </app-cells>
      </template>
      <app-cells v-if="table_hotels_stop.length" :indent="false">
        <h2 class="title title--mb15">Stop</h2>
      </app-cells>
      <template v-if="table_hotels_stop.length">
        <AppAccHotel
          v-for="(item, index) in table_hotels_stop"
          :key="`hotel_stop_${item.id}`"
          :reservation="item.reservation"
          :order-number="index + 1"
        />
        <app-cells :position="pagination_hotels_stop.pages > 1 ? 'between' : 'end'">
          <paginate
            :clickHandler="onClickHotelsStopPagination"
            v-if="pagination_hotels_stop.pages > 1"
            v-model="pagination_hotels_stop.page"
            :page-count="pagination_hotels_stop.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
          <app-table-records
            :all="pagination_hotels_stop.count"
            :count="table_hotels_stop.length"
            :page="pagination_hotels_stop.page"
          />
        </app-cells>
      </template>
      <app-cells :indent="false">
        <h2 class="title title--mb15">New</h2>
      </app-cells>
      <template v-if="table_hotels_new.length">
        <AppAccHotel
          v-for="(item, index) in table_hotels_new"
          :key="`hotel_new_${item.id}`"
          :reservation="item.reservation"
          :order-number="index + 1"
        />
        <app-cells :position="pagination_hotels_new.pages > 1 ? 'between' : 'end'">
          <paginate
            :clickHandler="onClickHotelsNewPagination"
            v-if="pagination_hotels_new.pages > 1"
            v-model="pagination_hotels_new.page"
            :page-count="pagination_hotels_new.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
          <app-table-records :all="pagination_hotels_new.count" :count="table_hotels_new.length" :page="pagination_hotels_new.page" />
        </app-cells>
      </template>
      <app-no-results v-if="!table_hotels_new.length" text="There’s no reservations yet" />
      <app-cells v-if="table_hotels_waiting.length">
        <h2 class="title">Waiting sales confirmation</h2>
      </app-cells>
      <template v-if="table_hotels_waiting.length">
        <AppAccHotel
          v-for="(item, index) in table_hotels_waiting"
          :key="`hotel_waiting_${item.id}`"
          :reservation="item.reservation"
          :order-number="index + 1"
        />
        <app-cells :position="pagination_hotels_waiting.pages > 1 ? 'between' : 'end'">
          <paginate
            :clickHandler="onClickHotelsWaitingPagination"
            v-if="pagination_hotels_waiting.pages > 1"
            v-model="pagination_hotels_waiting.page"
            :page-count="pagination_hotels_waiting.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
          <app-table-records
            :all="pagination_hotels_waiting.count"
            :count="table_hotels_waiting.length"
            :page="pagination_hotels_waiting.page"
          />
        </app-cells>
      </template>
    </app-page-container>
  </div>
</template>

<script>
import { getReservationsHotelAmendmentRequests } from '@/http'
import AppAccHotel from '@/components/AppAccHotel.vue'

export default {
  name: 'HotelsAmendmentsPending',
  components: { AppAccHotel },
  data() {
    return {
      is_loaded: false,
      table_hotels_proceed: [],
      table_hotels_stop: [],
      table_hotels_new: [],
      table_hotels_waiting: [],
      pagination_hotels_proceed: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_hotels_stop: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_hotels_new: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_hotels_waiting: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    onClickHotelsProceedPagination(page) {
      this.pagination_hotels_proceed.page = page
      this.fetchHotelsProceedItems()
    },
    onClickHotelsStopPagination(page) {
      this.pagination_hotels_stop.page = page
      this.fetchHotelsStopItems()
    },
    onClickHotelsNewPagination(page) {
      this.pagination_hotels_new.page = page
      this.fetchHotelsNewItems()
    },
    onClickHotelsWaitingPagination(page) {
      this.pagination_hotels_waiting.page = page
      this.fetchHotelsWaitingItems()
    },

    fetchHotelsProceedItems() {
      getReservationsHotelAmendmentRequests(
        {
          sales_status: 'proceed',
          reservation_status__complete: false,
          page: this.pagination_hotels_proceed.page,
          page_size: 20
        }
      )
        .then(res => {
          this.table_hotels_proceed = res.data.results
          this.pagination_hotels_proceed.pages = res.data.pages
          this.pagination_hotels_proceed.count = res.data.count
          this.is_loaded = true
        })
    },
    fetchHotelsStopItems() {
      getReservationsHotelAmendmentRequests(
        {
          sales_status: 'stop',
          reservation_status_exclude: 'stopped',
          page: this.pagination_hotels_stop.page,
          page_size: 20
        }
      )
        .then(res => {
          this.table_hotels_stop = res.data.results
          this.pagination_hotels_stop.pages = res.data.pages
          this.pagination_hotels_stop.count = res.data.count
          this.is_loaded = true
        })
    },
    fetchHotelsNewItems() {
      getReservationsHotelAmendmentRequests(
        {
          reservation_status: 'new',
          page: this.pagination_hotels_new.page,
          page_size: 20
        }
      )
        .then(res => {
          this.table_hotels_new = res.data.results
          this.pagination_hotels_new.pages = res.data.pages
          this.pagination_hotels_new.count = res.data.count
          this.is_loaded = true
        })
    },
    fetchHotelsWaitingItems() {
      getReservationsHotelAmendmentRequests(
        {
          reservation_status__request: true,
          reservation_status__complete: false,
          sales_status_exclude: 'stop,proceed',
          page: this.pagination_hotels_waiting.page,
          page_size: 20
        }
      )
        .then(res => {
          this.table_hotels_waiting = res.data.results
          this.pagination_hotels_waiting.pages = res.data.pages
          this.pagination_hotels_waiting.count = res.data.count
          this.is_loaded = true
        })
    },

    fetchItems() {
      Promise.all([
        getReservationsHotelAmendmentRequests(
          {
            sales_status: 'proceed',
            reservation_status__complete: false,
            page: this.pagination_hotels_proceed.page,
            page_size: 20
          }
        ),
        getReservationsHotelAmendmentRequests(
          {
            sales_status: 'stop',
            reservation_status_exclude: 'stopped',
            page: this.pagination_hotels_stop.page,
            page_size: 20
          }
        ),
        getReservationsHotelAmendmentRequests(
          {
            reservation_status: 'new',
            page: this.pagination_hotels_new.page,
            page_size: 20
          }
        ),
        getReservationsHotelAmendmentRequests(
          {
            reservation_status__request: true,
            reservation_status__complete: false,
            sales_status_exclude: 'stop,proceed',
            page: this.pagination_hotels_waiting.page,
            page_size: 20
          }
        ),
      ])
        .then(res => {
          this.table_hotels_proceed = res[0].data.results
          this.pagination_hotels_proceed.pages = res[0].data.pages
          this.pagination_hotels_proceed.count = res[0].data.count
          this.table_hotels_stop = res[1].data.results
          this.pagination_hotels_stop.pages = res[1].data.pages
          this.pagination_hotels_stop.count = res[1].data.count
          this.table_hotels_new = res[2].data.results
          this.pagination_hotels_new.pages = res[2].data.pages
          this.pagination_hotels_new.count = res[2].data.count
          this.table_hotels_waiting = res[3].data.results
          this.pagination_hotels_waiting.pages = res[3].data.pages
          this.pagination_hotels_waiting.count = res[3].data.count

          this.is_loaded = true
        })
    },
  }
}
</script>
